module.exports = __webpack_public_path__ + "img/DEFAULTBLOG.d5bf3c58.png";